import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { PurchaseOrderDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-order-dto';
import { InventoryWriteOffDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/WriteOffs/inventory-write-off-dto';
import { InventoryStockTransferDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfer-dto';
import { InventoryStockTakeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-take-dto';
import { StockItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-item-dto';
import { InventoryStockLineItemDto } from 'src/app/pos-panel/models/inventory/inventory-stock-line-item.model'
import { InventoryActionStatus } from 'src/app/pos-panel/enums/inventory-action-status.enum';
import { AddOrEditInventoryComponent } from '../inventory/add-or-edit-inventory/add-or-edit-inventory.component';
import { AddOrEditInventoryItemComponent } from '../add-or-edit-inventory-item/add-or-edit-inventory-item.component';
import { ItemWriteOffComponent } from '../item-write-off/item-write-off.component';
import { ItemRestockComponent } from '../item-restock/item-restock.component';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { InventoryService } from 'src/api/generated/services';
import { GetPurchaseOrders$Params } from 'src/api/generated/fn/inventory/get-purchase-orders';
import { GetInventoryWriteOffs$Params } from 'src/api/generated/fn/inventory/get-inventory-write-offs';
import { GetStockTransfers$Params } from 'src/api/generated/fn/inventory/get-stock-transfers';
import { GetInventoryStockTakes$Params } from 'src/api/generated/fn/inventory/get-inventory-stock-takes';
import { RemoveInventory$Params } from 'src/api/generated/fn/inventory/remove-inventory';
import { GetInventory$Params } from 'src/api/generated/fn/inventory/get-inventory';
import { GetInventoryStockItems$Params } from 'src/api/generated/fn/inventory/get-inventory-stock-items';
import { InventoryStockDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-stock-dto';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { CurrencyService } from 'src/app/pos-panel/services/currency-helper/currency.service';
import { MenuCurrencyDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';
import * as moment from 'moment';


@Component({
  selector: 'app-inventory-details',
  templateUrl: './inventory-details.component.html',
  styleUrls: ['./inventory-details.component.scss']
})
export class InventoryDetailsComponent implements OnInit, OnDestroy {
  
  inventory: InventoryDto | null = null;
  venueId: string;
  inventoryId: string;
  activeIndex: number = 0;

  InventoryActionStatus = InventoryActionStatus;
  venueIdUpdateSubscription: Subscription;

  inventoryStockItemsList: Array<InventoryStockDto> ;
  searchStockItem: string = ""
  loadingStockItems: boolean = false;
  
  purchaseOrders: Array<PurchaseOrderDto>;
  searchOrders: string = ""
  loadingOrders: boolean = false;

  writeOffs: Array<InventoryWriteOffDto>;
  searchWriteOffs: string = ""
  loadingWriteOffs: boolean = false;

  transfers: Array<InventoryStockTransferDto>;
  searchTransfers: string = ""
  loadingTransfers: boolean = false;

  stockTakes: Array<InventoryStockTakeDto>;
  searchStockTakes: string = ""
  loadingStockTakes: boolean = false;

  searchDebouncerStockItems = new Subject<void>();
  searchDebouncerPurchaseOrders = new Subject<void>();
  searchDebouncerWriteOffs = new Subject<void>();
  searchDebouncerTransfers = new Subject<void>();
  searchDebouncerStockTakes = new Subject<void>();

  timezoneOffset: any;

  RELOAD_DEBOUNCE_TIME = 500;

  measurementUnits: any;
  currency: MenuCurrencyDto;

  constructor(private _location: Location,
              private route: ActivatedRoute,
              public router: Router,
              public dialogService: DialogService,
              private confirmationService: ConfirmationService,
              public translate: TranslateService, 
              public currencyService: CurrencyService,
              private inventoryService: InventoryService,
              private currentVenueHelper: CurrentVenueHelperService,
              private messageService: MessageService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.inventoryService.getMeasurementUnitTypes().subscribe(response => this.measurementUnits = response );
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.currentVenueHelper.getTimezone().subscribe(tzOffset => this.timezoneOffset = tzOffset);
      }
      if (params['inventory-id'] != null) {
        this.inventoryId = params['inventory-id'];
        const inventoryParams: GetInventory$Params = { inventoryId: params['inventory-id']};
        this.inventoryService.getInventory(inventoryParams).subscribe({
          next: response => {
            this.inventory = response;
            this.refreshData();
          }, 
          error: errorResponse => {
            this.router.navigate([this.venueId, 'dashboard']);
          }
        });
      }
    });
    this.currencyService.currencyObservable().subscribe(currency => this.currency = currency);
    this.route.queryParams.subscribe(params => {
      if(params['activeIndex']){
          this.activeIndex = params['activeIndex'];
          if(this.inventory && this.inventory.id != undefined){
            this.refreshData();
          }
        }
      });

    this.searchDebouncerStockItems.pipe(
      debounceTime(this.RELOAD_DEBOUNCE_TIME)
    ).subscribe(_ => this.loadInventoryStock());

    this.searchDebouncerPurchaseOrders.pipe(
      debounceTime(this.RELOAD_DEBOUNCE_TIME)
    ).subscribe(_ => this.loadPurchaseOrders());

    this.searchDebouncerWriteOffs.pipe(
      debounceTime(this.RELOAD_DEBOUNCE_TIME)
    ).subscribe(_ => this.loadWriteOffs());

    this.searchDebouncerTransfers.pipe(
      debounceTime(this.RELOAD_DEBOUNCE_TIME)
    ).subscribe(_ => this.loadTransfers());

    this.searchDebouncerStockTakes.pipe(
      debounceTime(this.RELOAD_DEBOUNCE_TIME)
    ).subscribe(_ => this.loadStockTakes());
  }
  
  changeTab(e: any) {
    this.activeIndex = e.index;
    this.router.navigate([], 
      {
        relativeTo: this.route,
        queryParams:{ activeIndex: this.activeIndex }, 
        queryParamsHandling: 'merge',
      });
  }

  refreshData(){
    if(this.inventory){
      if(this.inventory.isMain){
        if (this.activeIndex == 0) {
          this.loadInventoryStock();
        } else if (this.activeIndex == 1){
            this.loadPurchaseOrders();
        } else if (this.activeIndex == 2){
            this.loadWriteOffs();
        } else if (this.activeIndex == 3){
            this.loadTransfers();
        } else if (this.activeIndex == 4){
            this.loadStockTakes();
        }
      }else {
        if (this.activeIndex == 0) {
          this.loadInventoryStock();
        } else if (this.activeIndex == 1){
          this.loadWriteOffs();
        } else if (this.activeIndex == 2){
          this.loadTransfers();
        } else if (this.activeIndex == 3){
          this.loadStockTakes();
        } 
      }
    }
  }

  loadInventoryStock(){
    this.loadingStockItems = true;
    var params: GetInventoryStockItems$Params = { inventoryId: this.inventoryId };
    if(this.searchStockItem){
      params.searchTerm = this.searchStockItem;
    }
    this.inventoryService.getInventoryStockItems(params).subscribe(response => {
      this.loadingStockItems = false;
      this.inventoryStockItemsList = response.stockItems ? response.stockItems : [];
    })
  }
  searchTermInventoryStock(): void {
    this.loadingStockItems = true;
    this.searchDebouncerStockItems.next();
  }

  loadPurchaseOrders(){
    this.loadingOrders = true;
    var purchaseOrderParams: GetPurchaseOrders$Params = { inventoryId: this.inventoryId };
    if(this.searchOrders){
      purchaseOrderParams.searchTerm = this.searchOrders;
    }
    this.inventoryService.getPurchaseOrders(purchaseOrderParams).subscribe( response => {
      this.loadingOrders = false;
      this.purchaseOrders = response.purchaseOrders ? response.purchaseOrders : [];
    });
  }
  searchTermPurchaseOrdersChange(): void {
    this.loadingOrders = true;
    this.searchDebouncerPurchaseOrders.next();
  }
  
  loadWriteOffs(){
    this.loadingWriteOffs = true;
    var writeOffsParams: GetInventoryWriteOffs$Params = { inventoryId: this.inventoryId };
    if(this.searchWriteOffs){
      writeOffsParams.searchTerm = this.searchWriteOffs;
    }
    this.inventoryService.getInventoryWriteOffs(writeOffsParams).subscribe( response => {
      this.loadingWriteOffs = false;
      this.writeOffs = response.writeOffs ? response.writeOffs : [];
    });
  }
  searchTermWriteOffs(): void {
    this.loadingWriteOffs = true;
    this.searchDebouncerWriteOffs.next();
  }

  loadTransfers(){
    this.loadingTransfers = true;
    var transfersParams: GetStockTransfers$Params =  { inventoryId: this.inventoryId};
    if(this.searchTransfers){
      transfersParams.searchTerm = this.searchTransfers;
    }
    this.inventoryService.getStockTransfers(transfersParams).subscribe( response => {
      this.transfers = response.transfers ? response.transfers : [];
      this.loadingTransfers = false;
    });
  }
  searchTermTransfers(): void {
    this.loadingTransfers = true;
    this.searchDebouncerTransfers.next();
  }

  loadStockTakes(){
    this.loadingStockTakes = true;
    var stockTakesParams: GetInventoryStockTakes$Params = { inventoryId: this.inventoryId };
    if(this.searchStockTakes){
      stockTakesParams.searchTerm = this.searchStockTakes;
    }
      this.inventoryService.getInventoryStockTakes(stockTakesParams).subscribe( response => {
        this.loadingStockTakes = false;
        this.stockTakes = response.stockTakes ? response.stockTakes : [];
      });
  }
  searchTermStockTakes(): void {
    this.loadingStockTakes = true;
    this.searchDebouncerStockTakes.next();
  }

  public editInventory(){
    const ref = this.dialogService.open(AddOrEditInventoryComponent, {
      data: {
        inventoryId: this.inventory?.id,
        venueId: this.venueId
      },
      width: '372px',
      showHeader: false    
    });
    ref.onClose.subscribe((item: any) => {});
  }

  public deleteInventory(){
    this.confirmationService.confirm({
      header: this.translate.instant('INVENTORY.DELETE_CONFIRMATION_TITLE'),
      message: this.translate.instant('INVENTORY.DELETE_CONFIRMATION_TEXT') + this.inventory?.name + "?",
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        const params: RemoveInventory$Params = { inventoryId: this.inventoryId };
        this.inventoryService.removeInventory(params).subscribe(response => {
          this.router.navigate([this.venueId, "inventory"]);
        });
      }
    });
  }

  goToInventories() {
    this.router.navigate([this.venueId, "inventory"])
  }
  
  //Inventory List Tab
  newInventoryItem(){
    const ref = this.dialogService.open(AddOrEditInventoryItemComponent, {
      width: '372px',
      showHeader: false
    });
    ref.onClose.subscribe((result: any) => {
      if(result){
        if (result.error) {
          this.messageService.add( { severity: 'error', summary: 'Creating item failed!', life: 3000 } );
        }else {
          this.messageService.add( { severity: 'success', summary: 'Item was successfully added!', life: 3000 } );
        }
      }
    });
  }
  
  editInventoryItem(item: StockItemDto){
    const ref = this.dialogService.open(AddOrEditInventoryItemComponent, {
      data: {
        id: item.id
      },
      width: '372px',
      showHeader: false
    });
    ref.onClose.subscribe((result: any) => {
      if(result){
        if (result.error) {
          this.messageService.add( { severity: 'error', summary: 'Updating item failed!', life: 3000 } );
        }else {
          this.messageService.add( { severity: 'success', summary: 'Item was successfully updated!', life: 3000 } );
          this.loadInventoryStock();
        }
      }
    });
  }

  writeOffItem(item: StockItemDto){
    const ref = this.dialogService.open(ItemWriteOffComponent, {
      data: {
        stockItemId: item.id,
        inventoryId: this.inventoryId
      },
      width: '372px',
      showHeader: false
    });

    ref.onClose.subscribe( result => {
      if(result){
        if (result.error) {
          this.messageService.add( { severity: 'error', summary: 'Item write off failed!', life: 3000 } );
        }else {
          this.messageService.add( { severity: 'success', summary: 'Item was successfully written off!', life: 3000 } );
          this.loadInventoryStock();
        }
      }
    });
  }

  restockItem(item: StockItemDto){
    const ref = this.dialogService.open(ItemRestockComponent, {
      data:{
        inventoryId: this.inventoryId,
        stockItemId: item.id
      },
      width: '488px',
      showHeader: false
    });

    ref.onClose.subscribe( result => {
      if(result){
        if (result.error) {
          this.messageService.add( { severity: 'error', summary: 'Item restock failed!', life: 3000 } );
        }else {
          this.messageService.add( { severity: 'success', summary: 'Item was successfully restocked!', life: 3000 } );
          this.loadInventoryStock();
        }
      }
    });
  }

  //Purchase Orders Tab
  newPurchaseOrder(){
    this.router.navigate([this.venueId, "inventory", this.inventoryId, "new-purchase-order"]);
  }

  purchaseOrderDetails(purchaseOrder: PurchaseOrderDto){
    if(purchaseOrder.statusType == InventoryActionStatus.Pending || purchaseOrder.statusType == InventoryActionStatus.Cancelled){
      this.router.navigate([this.venueId, "inventory", this.inventoryId, "purchase-orders", purchaseOrder.id ]);
    }else {
      this.router.navigate([this.venueId, "inventory", this.inventoryId, "received-purchase-orders", purchaseOrder.id]);
    }
  }

  printPurchaseOrder(purchaseOrderId: string){

  }

  purchaseOrderReceipt(purchaseOrder: PurchaseOrderDto){
    this.router.navigate([this.venueId, "inventory", this.inventoryId, "purchase-order-receipts", purchaseOrder.id]);
  }

  //Transfers Tab
  newTransfer(){
    this.router.navigate([this.venueId, "inventory", this.inventoryId, "new-outgoing-transfer"]);
  }

  openTransferReceipt(transfer: InventoryStockTransferDto){
    this.router.navigate([this.venueId, "inventory", this.inventoryId, "transfer-receipts", transfer.id]);
  }

  openTrasferDetails(transfer: InventoryStockTransferDto) {
    if(transfer.sourceVenueInventory != undefined) {
    if(transfer.sourceVenueInventory.id == this.inventoryId){
        this.router.navigate([this.venueId, "inventory", this.inventoryId, "outgoing-transfer", transfer.id])
      }else {
        this.router.navigate([this.venueId, "inventory", this.inventoryId, "incoming-transfer", transfer.id])
      }
    }
  }

  //Stock Takes Tab
  newStockTake(){
    this.router.navigate([this.venueId, "inventory", this.inventoryId, "new-stock-take"]);
  }

  completeStockTake(stockTakeId: string){
    this.router.navigate([this.venueId, "inventory", this.inventoryId, "complete-stock-take", stockTakeId]);

  }
  stockTakeDetails(stockTakeId: string){
    this.router.navigate([this.venueId, "inventory", this.inventoryId, "stock-take", stockTakeId]);
  }
  
  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
